import styled from '@emotion/styled';
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Tabs, Tab } from '@mui/material';
import { useState } from 'react';

import PageHeader from '../../../components/PageHeader';

import TablePersonBlacklist from './TablePersonBlacklist';
import TableCompanyBlacklist from './TableCompanyBlacklist';

enum ControlType {
  Person = 'person',
  Company = 'company'
}

const BlacklistPage = () => {
  const [controlType, setControlType] = useState<ControlType>(ControlType.Person);

  return (
    <Container>
      <PageHeader text="Blacklist" />
      <TabContext value={controlType}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={controlType} onChange={(_, value) => setControlType(value)} aria-label="">
            <Tab label="บุคคล" value={ControlType.Person} />
            <Tab label="บริษัท" value={ControlType.Company} />
          </Tabs>
        </Box>
        <TabPanel value={ControlType.Person} sx={{ p: 1, pt: 2 }}>
          <TablePersonBlacklist />
        </TabPanel>
        <TabPanel value={ControlType.Company} sx={{ p: 1, pt: 2 }}>
          <TableCompanyBlacklist />
        </TabPanel>
      </TabContext>
    </Container>
  );
};

export default BlacklistPage;

const Container = styled('div')`
  padding: 16px;
`;
